import "./styles/main.scss";

import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import App from "./App";
import { TicketingContextProvider } from "./store";

if (!document.querySelector(".ticket-view-container")) {
  const element = document.createElement("div");
  element.classList.add("ticket-view-container");
  document.body.appendChild(element);

  const queryClient = new QueryClient();

  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <TicketingContextProvider>
        <App />
      </TicketingContextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
    element
  );
}
